import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ThemeService } from '../service/theme.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../local-storage.service';
import { ClientService } from '../service/client.service';
import { IotService } from '../service/iot.service';
import { CustomMultiSelectComponent } from '../custom-multi-select/custom-multi-select.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BinsService } from '../service/bins.service';
import { ReportsService } from '../service/reports.service';
import { FilterService } from '../service/filter.service';
import { SystemMessageService } from '../service/system-message.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'SubGroupModalComponent',
  templateUrl: './sub-group-modal.component.html',
  styleUrls: [
    '../iot/iot-component.css',
    './sub-group-modal.component.css',
    '../../global-elements.css',
    '../bin-create/bin-create.component.css',
  ],
  standalone: false,
})
export class SubGroupModalComponent implements OnInit {
  public subGroupName: string = ''; // The subgroup name
  public selectedThings: string = '';
  public client_id: string = '';
  public tab: string = '';
  public thingClient: any;
  public things: any;
  public sortDirection: string = '';
  public sortBy: string = 'thingName';
  public allThingsShadowFeed: boolean = false;
  public selectedThingsShadowFeed: string[] = [];
  public showStateInfo: boolean[] = [];
  public filteredDevicesArray: any;
  public selectedDevices: any = [];
  public clientSubGroups: any = [];
  public AddRemoveDeviceOpen: boolean = false;
  public startDateShadowFeed: any = this.reports.getCurrentDate();
  public endDateShadowFeed: any = this.reports.getCurrentDate();
  public thingsShadowLog: any[] = [];
  @ViewChild(CustomMultiSelectComponent)
  selectComponent!: CustomMultiSelectComponent;
  public thingStatusArray: any;
  public subGroupFilter: string = '';
  public availableDevices: any;
  public AddDeviceTosubGroupFilter: string = '';
  public selectedSubGroup: any;
  public originalClientSubGroups: any;
  public ascending: boolean = true;
  public deviceDeletion: boolean = false;
  public subGroupToDelete: any;
  public currentSubGroupId: string = ''; // The subgroup being deleted
  public devicesInCurrentSubGroup: any[] = []; // Fill this with the devices before showing modal
  public selectedGlobalSubgroupId: string = '';
  public deviceTransferMap: { [thingName: string]: string } = {};
  public deviceSelectionMap: { [thingName: string]: boolean } = {}; // Tracks checkbox state
  public selectAll: boolean = false;
  public expandedSubGroups = new Map<number, boolean>(); // to track expanded device tables
  public loading: boolean = false;
  trackByThingName = (_: number, d: { thingName: string }) => d.thingName;
  constructor(
    private localStorageService: LocalStorageService,
    public clientService: ClientService,
    public reports: ReportsService,
    public iotService: IotService,
    private renderer: Renderer2,
    public router: Router,
    public route: ActivatedRoute,
    public systemMessage: SystemMessageService,
    public binService: BinsService,
    @Inject(forwardRef(() => TranslateService))
    private translate: TranslateService,
    public filter: FilterService,
    public theme: ThemeService,
    private cd: ChangeDetectorRef
  ) {
    this.thingClient = [];
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.iotService.devicesArray = [];
    this.selectedDevices = [];
    this.subGroupName = '';
    this.loading = true;
    // Fetch the list of clients
    this.getClientList();
    this.route.params.subscribe((params) => {
      // get client_id

      this.tab = params['tab'];
    });
    if (this.tab === 'create') {
      this.selectedDevices = [];
    }
    this.client_id = this.route.snapshot.params['client_id']; // get client_id

    this.filteredDevicesArray = await this.iotService.getThingListByClient(
      this.client_id
    ); // get client devices
    this.filteredDevicesArray = this.dedupeDevicesByThingName(
      this.filteredDevicesArray
    );
    this.iotService.devicesArray = this.dedupeDevicesByThingName(
      this.iotService.devicesArray
    );
    await this.iotService.countDashboardDevicesAndParameters().then((res) => {
      //get status array for table
      this.thingStatusArray = JSON.parse(res.status);
    });
    await this.loadClientSubGroups(); // init client subroups

    //Bandaid fix for duplicate devices showing in add device to subgroup modal
    this.filteredDevicesArray = this.dedupeDevicesByThingName(
      this.filteredDevicesArray
    );
    this.iotService.devicesArray = this.dedupeDevicesByThingName(
      this.iotService.devicesArray
    );

    this.loading = false;
  }
  /**
   * Fetch the list of clients
   * */
  async getClientList(): Promise<void> {
    try {
      // Use the clientService to fetch client data from an API
      this.thingClient = await firstValueFrom(this.clientService.getClients());
    } catch (error) {
      console.error('Error getting client list: ', error);
    }
  }

  private dedupeDevicesByThingName(devices: any[] | undefined): any[] {
    const seenDevices = new Set<string>();
    return (devices || []).filter((device: any) => {
      const key = device?.thingName ?? device?.thing_name;
      if (!key) {
        return true;
      }
      if (seenDevices.has(key)) {
        return false;
      }
      seenDevices.add(key);
      return true;
    });
  }
  /**
   * Load the clientss subgroups
   * */
  async loadClientSubGroups(): Promise<void> {
    this.originalClientSubGroups = [];
    const response = await firstValueFrom(
      this.iotService.getClientSubGroups(this.client_id)
    );
    if (response) {
      try {
        // Store all subgroups
        this.originalClientSubGroups = response;
        this.clientSubGroups = response;
        this.clientSubGroups.forEach((subGroup: any) => {
          //Matching the device list name of the client to real device list
          const thingNames = subGroup.devices.map((d: any) => d.thing_name); // Extract device thing names from each subGroup
          const matchedDevices = this.filteredDevicesArray.filter(
            (
              device: any // Match them with the full filtered devices array
            ) => thingNames.includes(device.thingName)
          );
          // Add the matched devices to the subGroup
          subGroup.matchedDevices = matchedDevices;
          subGroup.expanded = matchedDevices.length <= 10; // device list under 10 devices?  load extended : load closed
          this.expandedSubGroups.set(subGroup.sub_groupID, subGroup.expanded); // track expanded state
        });
      } catch (error) {
        console.error('Error fetching client subgroups:', error);
      }
    }
  }
  /*
   *Function that close sub group create view and return to entities
   */
  cancelButton(): void {
    const previousRoute =
      this.localStorageService.getItem('fromSubGroupView') ||
      this.localStorageService.getItem('previousRoute');
    if (!previousRoute) {
      // If we are a client, redirect to client-thing-list
      if (this.localStorageService.getItem('client')) {
        this.router.navigate(['/client-thing-list']);
      } else {
        this.router.navigate(['/entities']);
      }
    } else {
      this.router.navigate([previousRoute]);
      this.localStorageService.removeItem('fromSubGroupView');
    }
  }
  /*
   *Function that create a new sub-group
   */
  async createSubGroup(): Promise<void> {
    try {
      try {
        await firstValueFrom(
          this.iotService.createDeviceSubGroup(
            this.subGroupName,
            this.client_id,
            this.selectedDevices
          )
        );
        //navigate and set tab view to sub group list
        const route = '/device-sub-group/view/' + this.client_id;
        this.router.navigateByUrl(route);
        this.tab === 'view';
        this.systemMessage.selectRibbon('success', 'subGroupCreate'); //succes message
        this.loadClientSubGroups(); //load client sub-group to get latest list
        this.subGroupName = '';
      } catch (error) {
        console.error('Error creating device subgroup:', error);
        this.systemMessage.selectRibbon('danger', 'subGroupCreateError'); //error  message
      }
    } catch (error) {
      console.error('error creating device subgroup: ' + error);
    }
  }
  /**
   * Function that navigates to the create subgroups page
   */
  toCreateSubGroup(): void {
    this.selectedDevices = []; // Empties selected array devices to remove previous selected devices
    const from = '/device-sub-group/view/' + this.client_id;
    this.localStorageService.addItem('fromSubGroupView', from);
    const route = '/device-sub-group/create/' + this.client_id;
    this.router.navigateByUrl(route);
    this.selectedDevices = [];
    this.subGroupName = '';
  }
  /**
   * Function that close the Add / remove device modal
   */
  closeModal(): void {
    this.AddRemoveDeviceOpen = false;
    this.selectedDevices = [];
  }

  /**
   * Opens the "Add Device to Subgroup" modal with the list of available devices.
   * @param subGroupID - The ID of the targeted sub-group.
   */
  addDevice(subGroupID: string): void {
    this.selectedDevices = [];
    //Get targeted sub-group
    this.selectedSubGroup = this.clientSubGroups.find(
      (group: any) => group.sub_groupID === subGroupID
    );
    if (this.selectedSubGroup) {
      //get the lsit of device in sub-group
      const usedThingNames = this.selectedSubGroup.devices.map(
        (d: any) => d.thing_name
      );
      // Filter devices that are NOT in the subgroup
      this.availableDevices = this.filteredDevicesArray.filter(
        (device: any) => !usedThingNames.includes(device.thingName)
      );
    } else {
      // fallback: if no match, show all devices
      this.availableDevices = [...this.iotService.devicesArray];
    }
    this.AddRemoveDeviceOpen = !this.AddRemoveDeviceOpen; // close modal
  }
  /**
   * Function that removes a device from a sub-group
   * @param deviceName - The name of the device to remove
   * @param subGroupID - The id of the sub-group
   */
  async removeDevice(deviceName: string, subGroupID: any): Promise<void> {
    await firstValueFrom(
      this.iotService.removeDevicesFromSubGroup([deviceName], subGroupID)
    );

    try {
      this.loadClientSubGroups(); // load updated subroup list
      this.systemMessage.selectRibbon('success', 'deviceRemoved'); // succes message
    } catch (error) {
      console.error(error); // succes message
      this.systemMessage.selectRibbon('danger', 'errorDeviceRemoved'); // Error message
    }
  }

  /**
   * Function that updates the subroup list of teh add device to sub-group modal
   */
  OnAddDeviceTosubGroupFilterChange(): void {
    this.availableDevices = this.filter.search(
      this.AddDeviceTosubGroupFilter,
      this.availableDevices,
      this.iotService.devicesArray,
      'thingName'
    );
  }

  /**
   * Function that updates the subroup list of teh add device to sub-group modal
   */
  onSubGroupFilterChange(): void {
    this.clientSubGroups = this.filter.search(
      this.subGroupFilter,
      this.clientSubGroups,
      this.originalClientSubGroups,
      'sub_group_name'
    );
  }

  /**
   * Function that add selected device(s) to the selected subgroup
   */
  async addToSubGroup(): Promise<void> {
    try {
      await firstValueFrom(
        this.iotService.addDevicesToSubGroup(
          this.selectedDevices,
          this.selectedSubGroup.sub_groupID
        )
      );
      this.selectedDevices = []; // reset the selected device array
      this.loadClientSubGroups(); // laod updated sub-group list
      this.AddRemoveDeviceOpen = false; // close modal
      this.systemMessage.selectRibbon('success', 'deviceAdded'); //sucess message
    } catch (error) {
      console.error(error);
      this.systemMessage.selectRibbon('danger', 'deviceAddedError'); //Error message
    }
  }

  /**
   * Function that assigns a numerical order to sub-groups based on their associated devices.
   */
  changeOrder(): void {
    // Use spread operator to create a new array of sorted sub-groups for changeDetectorRef
    const sorted = [...this.clientSubGroups].sort((a, b) => {
      const aCount = a.devices.length;
      const bCount = b.devices.length;
      return this.ascending ? aCount - bCount : bCount - aCount;
    });
    this.clientSubGroups = sorted; // display sorted list
    this.ascending = !this.ascending; // change order for UI arrow
  }

  /**
   * Function that close the delete sub-group modal
   */
  closeSubGroupDeleteModal(): void {
    this.deviceDeletion = false; // close modal
    this.selectedDevices = [];
    this.devicesInCurrentSubGroup = []; //reset delete device array
    this.deviceTransferMap = {}; // reset device transfer map
    this.deviceSelectionMap = {}; // reset device seelction map
    this.selectedGlobalSubgroupId = ''; // reset te global transfer selected sub-group
    this.selectAll = false; // reset select all checkbox
  }

  /**
   * Function that opens the delete sub-group modal
   */
  openSubGroupDeleteModal(subGroupId: string): void {
    // Get  sub-group to delete
    this.currentSubGroupId = subGroupId;
    this.subGroupToDelete = this.clientSubGroups.find((sg: any) => {
      return sg.sub_groupID === subGroupId;
    });
    this.deviceDeletion = true; // opens modal;
    this.devicesInCurrentSubGroup = this.subGroupToDelete?.matchedDevices || []; //Get devices in sub-group
    // Initialize map with each device in sub-group
    this.deviceTransferMap = {};

    for (const device of this.devicesInCurrentSubGroup) {
      if (this.devicesInCurrentSubGroup.length === 1) {
        this.deviceSelectionMap[device.thingName] = device.thingName;
        //this.deviceTransferMap[device.thingName] = device.thingName;
        return;
      }
      this.deviceTransferMap[device.thingName] = '';
    }
  }

  /**
   * Function that assign devices to selected sub-group in the device transfer map
   */
  assignAllDevicesToSelectedGroup(): void {
    for (const device of this.devicesInCurrentSubGroup) {
      if (this.deviceSelectionMap[device.thingName]) {
        this.deviceTransferMap[device.thingName] =
          this.selectedGlobalSubgroupId;
      }
    }
  }

  /**
   * Function that delete and reasigne devices if needed.
   *  @param mode - Mode 1 delete sub-group ; Mode 2  delete and reassigne devices in transferMap
   */
  async confirmSubGroupDeletion(mode: number): Promise<void> {
    switch (mode) {
      /* Delete subroup */
      case 1:
        try {
          await firstValueFrom(
            this.iotService.deleteSubGroup(this.subGroupToDelete.sub_groupID)
          );
          this.systemMessage.selectRibbon('succes', 'subGroupDelete'); // Succes message
          this.subGroupToDelete = undefined;
          this.loadClientSubGroups(); // laod updated sub-group list
          this.closeSubGroupDeleteModal(); // close modal
        } catch (error) {
          console.error(error);
          this.systemMessage.selectRibbon('danger', 'subGroupDeleteError'); // Error message
        }
        break;
      /* Delete subroup & Reassigne devices in transferMap*/
      case 2:
        try {
          const transferMap = this.getSelectedTransfers();
          await firstValueFrom(
            this.iotService.deleteSubGroup(
              this.subGroupToDelete.sub_groupID,
              transferMap
            )
          );
          this.systemMessage.selectRibbon('succes', 'subGroupDelete'); // Succes message
          this.subGroupToDelete = undefined;
          this.loadClientSubGroups(); // laod updated sub-group list
          this.closeSubGroupDeleteModal(); // close modal
        } catch (error) {
          this.systemMessage.selectRibbon('danger', 'subGroupDeleteError'); // Error message
        }
        break;
    }
    this.selectedDevices = [];
  }

  /**
   * Function that select devices in the delete sub-group modal
   *  @param thingName - device name
   */
  onDeviceSelectChange(thingName: string): void {
    if (!this.deviceSelectionMap[thingName]) {
      delete this.deviceTransferMap[thingName];
    }
  }

  /**
   * Function that select all devices in the delete sub-group modal
   */
  onSelectAllChange(): void {
    for (let device of this.devicesInCurrentSubGroup) {
      this.deviceSelectionMap[device.thingName] = this.selectAll;

      if (this.selectAll && !this.deviceTransferMap[device.thingName]) {
        this.deviceTransferMap[device.thingName] = '';
      }
    }
  }

  /**
   * Function that returns an array of selected devices along with their corresponding target sub-group IDs.
   * @Returns Each entry contains the device name (`thingName`) and the selected target group (`targetGroup`).
   */
  getSelectedTransfers(): { thingName: string; targetGroup: string }[] {
    return Object.keys(this.deviceSelectionMap)
      .filter(
        (thingName) =>
          this.deviceSelectionMap[thingName] === true &&
          this.deviceTransferMap[thingName] != ''
      )
      .map((thingName) => ({
        thingName,
        targetGroup: this.deviceTransferMap[thingName],
      }));
  }

  /**
   * Funtion that determines whether the "Reassign & Delete" button should be disabled.
   * @Returns true if
   * - No devices are selected
   * - At least one selected device does not have a target transfer group assigned.
   */
  isReassignDeleteDisabled(): boolean {
    const selected = Object.keys(this.deviceSelectionMap).filter(
      (key) => this.deviceSelectionMap[key]
    );

    if (selected.length === 0) {
      return true;
    }

    // Check if any selected device is missing a valid subgroup
    return selected.some((thingName) => {
      const target = this.deviceTransferMap[thingName];
      return target === undefined || target === null || target === '';
    });
  }
  /**
   * Toggles the expanded state of a sub-group by its ID.
   * @param subGroupId - Sub-group id
   */
  toggleSubGroup(subGroupId: number): void {
    const index = this.clientSubGroups.findIndex(
      (sg: any) => sg.sub_groupID === subGroupId
    );

    if (index !== -1) {
      const sg = this.clientSubGroups[index];
      // Replace the object entirely to trigger change detection
      this.clientSubGroups[index] = {
        ...sg,
        expanded: !sg.expanded,
      };
    }
  }

  /**
   * Listenes for window resize to close opened device barner on mobile view change
   */
  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth > 850) {
      this.closeAllDeviceInfoBanners();
    }
  }

  /**
   * Function that closes all device banners opened in mobile when transiotion to a bigger view
   */
  closeAllDeviceInfoBanners(): void {
    //Get the opened banners
    const openBanners = document.querySelectorAll('.deviceInfo.open');
    //Safely exit if none found
    if (openBanners.length === 0) {
      return;
    }
    openBanners.forEach((element: Element) => {
      const banner = element as HTMLElement;
      const arrow = document.getElementsByClassName(
        banner.id
      )[0] as HTMLElement;
      //Close the  banner
      this.renderer.addClass(banner, 'hidden');
      this.renderer.removeClass(banner, 'open');
      //Flip associated arrow back to closed position
      if (arrow) {
        this.renderer.removeClass(arrow, 'open');
        this.flipBack(arrow);
      }
    });
  }

  ///////////////// IMPORTED FUNCTIONS   /////////////////

  //function that toggles the device info element in mobile view
  toggleDeviceDetails(id: string): void {
    if (window.innerWidth >= 850) {
      return;
    }
    const element = document.getElementById(id);
    let arrow;
    if (element) {
      arrow = document.getElementsByClassName(element.id)[0] as HTMLElement;
    }
    //show the device info of clicked device
    if (element && element.classList.contains('hidden')) {
      this.renderer.removeClass(element, 'hidden');
      this.renderer.addClass(element, 'open');
      this.renderer.addClass(arrow, 'open');

      this.flip180(arrow);
    } else {
      this.renderer.addClass(element, 'hidden');
      this.renderer.removeClass(element, 'open');
      this.renderer.removeClass(arrow, 'open');

      this.flipBack(arrow);
    }
    this.hideDeviceDetails(element);
  }
  // Function used in mobile view to hide the device detail box that appear under the device row in the list
  hideDeviceDetails(el: HTMLElement | null): void {
    let filteredArray;
    if (el) {
      filteredArray = Array.from(
        document.querySelectorAll('.deviceInfo')
      ).filter((element) => element.id !== el.id);
      //hiddes the open device Info tab
      for (let el of filteredArray) {
        if (
          el &&
          !el.classList.contains('hidden') &&
          el.classList.contains('open')
        ) {
          this.renderer.addClass(el, 'hidden');
          this.renderer.removeClass(el, 'open');

          const arrow = document.querySelector(`.${el.id}`) as HTMLElement;
          this.flipBack(arrow);
        }
      }
    }
  }
  // functio that flips an element by 180 degrees
  flip180(element: HTMLElement | undefined): void {
    if (element) element.style.transform = `rotate(${180}deg)`;
  }
  // function that flips an element by 90 degrees
  flipBack(element: HTMLElement | undefined): void {
    if (element) element.style.transform = `rotate(${360}deg)`;
  }
  open(): void {
    this.selectComponent.open();
  }

  onCheckboxChange(event: Event, deviceName: string): void {
    const input = event.target as HTMLInputElement;
    const checked = input.checked;

    if (checked) {
      if (!this.selectedDevices.includes(deviceName)) {
        this.selectedDevices.push(deviceName);
      }
    } else {
      this.selectedDevices = this.selectedDevices.filter(
        (d: any) => d !== deviceName
      );
    }
  }

  sortItems(itemSortBy: string) {
    // Choose the sort direction if user click more than once on the same column
    if (this.sortBy === itemSortBy) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Else sort direction will be at ascendant
      this.sortDirection = 'asc';
    }

    // Reasign the value of sortyBy so next click system will know if it's the first click on the column
    this.sortBy = itemSortBy;

    // This will sort between each of the selected column by the user
    this.iotService.devicesArray.sort((a, b) => {
      switch (itemSortBy) {
        case 'thingName':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return b.thingName.localeCompare(a.thingName);
          } else {
            return a.thingName.localeCompare(b.thingName);
          }

        case 'vcc':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return b.dat.vcc - a.dat.vcc;
          } else {
            return a.dat.vcc - b.dat.vcc;
          }

        case 'battery':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return b.dat.bat - a.dat.bat;
          } else {
            return a.dat.bat - b.dat.bat;
          }

        case 'version':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return b.dat.fdv.localeCompare(a.dat.fdv);
          } else {
            return a.dat.fdv.localeCompare(b.dat.fdv);
          }

        case 'signal':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return b.dat.sig - a.dat.sig;
          } else {
            return a.dat.sig - b.dat.sig;
          }

        case 'nct':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return b.dat.nct - a.dat.nct;
          } else {
            return a.dat.nct - b.dat.nct;
          }

        case 'prodStatus':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return b.prodStatus!.status_index - a.prodStatus!.status_index;
          } else {
            return a.prodStatus!.status_index - b.prodStatus!.status_index;
          }

        case 'temperature':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return b.dat.tm2 - a.dat.tm2;
          } else {
            return a.dat.tm2 - b.dat.tm2;
          }

        case 'height':
          // This will sort asc or desc depending on the sort direction initialized up here
          if (this.sortDirection === 'asc') {
            return (b.bin?.bin_height || 0) - (a.bin?.bin_height || 0);
          } else {
            return (a.bin?.bin_height || 0) - (b.bin?.bin_height || 0);
          }

        case 'distance':
          // This will sort asc or desc depending on the sort direction initialized up here
          if (this.sortDirection === 'asc') {
            return (b.dat?.dst || 0) - (a.dat?.dst || 0);
          } else {
            return (a.dat?.dst || 0) - (b.dat?.dst || 0);
          }

        case 'status':
          if (this.sortDirection === 'asc') {
            return this.statusComparison(a, b);
          } else {
            return this.statusComparison(b, a);
          }

        case 'filled':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'desc') {
            return this.fillPercentageComparison(a, b);
          } else {
            return this.fillPercentageComparison(b, a);
          }

        case 'modal':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return (
              b.thingName.split('-')[0] +
              '-' +
              b.thingName.split('-')[1]
            ).localeCompare(
              a.thingName.split('-')[0] + '-' + a.thingName.split('-')[1]
            );
          } else {
            return (
              a.thingName.split('-')[0] +
              '-' +
              a.thingName.split('-')[1]
            ).localeCompare(
              b.thingName.split('-')[0] + '-' + b.thingName.split('-')[1]
            );
          }

        case 'date':
          // This will sort asc or desc depend on the sort direction initialize up here
          if (this.sortDirection === 'asc') {
            return b.lastUpdate - a.lastUpdate;
          } else {
            return a.lastUpdate - b.lastUpdate;
          }

        default:
          // Default will sort on thingName asc
          return a.thingName.localeCompare(b.thingName);
      }
    });
  }
  // This function compares the status of two objects.
  statusComparison = (a: any, b: any): number => {
    // Obtain the status of object 'a'
    const statusA = this.verifyStatus(a.thingName);
    // Obtain the status of object 'b'
    const statusB = this.verifyStatus(b.thingName);

    // Place 'Healthy' before 'Unhealthy' and 'Unhealthy' before 'Inactive'
    if (statusA === 'Healthy' && statusB !== 'Healthy') {
      return -1;
    } else if (statusA === 'Unhealthy' && statusB === 'Inactive') {
      return -1;
    } else if (statusA === 'Inactive' && statusB !== 'Inactive') {
      return 1;
    } else {
      // If statuses are the same or not covered by the previous conditions, return 0
      return 0;
    }
  };
  // Function used to get device status
  verifyStatus(thingName: string): string {
    if (this.thingStatusArray) {
      // Check if this.thingStatusArray is defined
      const array = this.thingStatusArray;
      const filteredDevices = array.filter(
        (device: any) => device.thing_name === thingName
      );
      if (filteredDevices.length > 0) {
        return filteredDevices[0].status as string; // Assuming there's only one device with the given thingName
      }
    }
    // Returns null or some default value if no match is found
    return 'Inactive';
  }
  // This function compares the fill percentage between two objects.
  fillPercentageComparison = (a: any, b: any): number => {
    // Calculate the fill percentage for object 'a'
    const fillPercentageA: number = this.calculateFillPercentage(
      a.bin?.bin_height,
      a.dat.dst
    );
    // Calculate the fill percentage for object 'b'
    const fillPercentageB: number = this.calculateFillPercentage(
      b.bin?.bin_height,
      b.dat.dst
    );
    // Compare the fill percentages of 'a' and 'b' and return the difference
    return fillPercentageA - fillPercentageB;
  };

  // Function return fill percentage of a bin if device is associated to one or 0 if not
  calculateFillPercentage(height: number = 0, dst: number = 0): number {
    if (height > 0 && dst >= 0) {
      let percentFilled = ((height - dst) / height) * 100;
      if (percentFilled < 0 && dst > height) {
        return 0;
      }
      return Math.round(percentFilled);
    } else {
      return 0;
    }
  }
  // Function called to get to shadow feed page with or without a device
  async goToShadowFeed(deviceName: string): Promise<void> {
    this.selectedThingsShadowFeed = [];
    this.selectedThingsShadowFeed.push(deviceName);
    await this.getShadowFeed();
  }
  async getShadowFeed(): Promise<void> {
    // Check first if user selected all devices
    if (this.allThingsShadowFeed) {
      this.selectedThingsShadowFeed = this.things.map((thing: any) => {
        return thing.name;
      });
    }

    // Set start date to timestamp
    const startDate = new Date(this.startDateShadowFeed);
    const timestampStartDateHour = startDate.setUTCHours(0, 0, 0);
    const timestampStartDate = Math.floor(timestampStartDateHour / 1000);

    // Set end date to timestamp
    const endDate = new Date(this.endDateShadowFeed);
    const timestampEndDateHour = endDate.setUTCHours(23, 59, 59);
    const timestampEndDate = Math.floor(timestampEndDateHour / 1000);

    const response = await this.iotService.getShadowFeed(
      this.selectedThingsShadowFeed,
      timestampStartDate,
      timestampEndDate
    );
    this.thingsShadowLog = response;

    // Replace the timestamp by the readable date time
    this.thingsShadowLog.forEach((log: any) => {
      const newDate = new Date(Math.floor(log.timestamp));

      // Call the funcitno in iotService to convert timestamp by yyyy-mm-dd hh:mm:ss
      log.timestamp = this.iotService.formatDate(newDate);
    });
  }
}
